<section>
    <form *ngIf="form" [formGroup]="form" (ngSubmit)="search()">
        <div class="field-block">
            <label>GTIN</label>
            <app-numberbox
                formControlName="gtin"
                placeholder="Поиск по GTIN"
                maxLength="14"
                name="GTIN">
            </app-numberbox>
        </div>
        <div class="field-block">
            <label i18n>Наименование</label>
            <app-textbox
                formControlName="name"
                placeholder="Поиск по наименованию"
                maxLength="512"
                name="Наименование">
            </app-textbox>
        </div>
        <button i18n [disabled]="!checkForm()" type="button" appSkin="simple-gray no-shadow bold" (click)="clearForm()">Сбросить</button>
        <button i18n [disabled]="isLoading" type="submit" appSkin="simple-gray no-shadow bold">Поиск</button>
    </form>
    <app-search-product-list
        [data]="data"
        [notFound]="notfound"
        (appSelect)="select($event)">
    </app-search-product-list>
</section>
